import Vue from "vue";
import { ActionTree } from "vuex";
import axios from "@/axios-config/default";
import { IRootState } from "@/store/types";
import { ANumberMutationsNames } from "./enums";
import { IANumberAssignment } from "@/models/anumberassignments";
import { IANumberGroup } from "@/models/anumbergroup";
import { IANumber } from "@/models/anumber";
import { IANumbersState } from ".";
import { IUuidsPayload } from "../../types";

export const actions: ActionTree<IANumbersState, IRootState> = {
    fetchANumberAssignmentsList({ commit }, ids: IUuidsPayload): void {
        axios
            .get(
                Vue.prototype.$environmentService.getServicePath("anumbers"),
                {
                    params: {
                        serviceProviderUuid: ids.uuidSP,
                        contentProviderUuid: ids.uuidCP,
                    },
                }
            )
            .then((response) => {
                if (response.status === 200) {
                    // mutation to storage sa scoped list
                    commit(
                        ANumberMutationsNames.SetANumberAssignments,
                        response.data
                    );
                }
            })
            .catch((error) => {
                // mutation to storage error
                commit(ANumberMutationsNames.SetANumberAssignmentError, error);
            });
    },
    fetchANumberGroupList({ commit }, ids: IUuidsPayload): void {
        axios
            .get(
                Vue.prototype.$environmentService.getServicePath(
                    "anumbergroups"
                ),
                {
                    params: {
                        serviceProviderUuid: ids.uuidSP,
                        contentProviderUuid: ids.uuidCP,
                    },
                }
            )
            .then((response) => {
                if (response.status === 200) {
                    // mutation to storage sa unscoped list
                    commit(
                        ANumberMutationsNames.SetANumberGroupList,
                        response.data
                    );
                }
            })
            .catch((error) => {
                // mutation to storage error
                commit(ANumberMutationsNames.SetANumberGroupError, error);
            });
    },
    setSelectedANumberAssignment(
        this,
        { commit },
        serviceAccount: IANumber
    ) {
        commit(
            ANumberMutationsNames.SetSelectedANumberAssignment,
            serviceAccount
        );
    },
    setANumberAssignments(this, { commit }, assignments: IANumber[]) {
        commit(ANumberMutationsNames.SetANumberAssignments, assignments);
    },
    setSelectedANumberGroup(this, { commit }, serviceAccount: IANumberGroup) {
        commit(ANumberMutationsNames.SetSelectedANumberGroup, serviceAccount);
    },
    resetServiceAccountState({ commit }): void {
        commit(ANumberMutationsNames.ResetState);
    },
};
